import React, { useEffect, useState } from "react";
import { apiUrl } from "../../Constants/Constants";
import styles from "./UserCard.module.css";
import CircularChart from "../CircularChart/CircularChart.module";
import ProgressBar from "../ProgressBar/ProgressBar.module";
import { AuthContext } from "../../Constants/AuthProvider";
import { Link, useNavigate } from "react-router-dom";
import NumberComponent from "../NumberComponent";
import { useFetchWithToken } from "./../FetchWithToken/FetchWithToken";
import { ConfirmationModalContext } from "../../fautures/ConfirmationModalProvider";
import Loading from "./../Loading/Loading.module"; // کامپوننت لودینگ
import { toast } from "react-toastify";
import CountrySelection from "./CountrySelection/CountrySelection.module";
import ChildLock from "./ChildLock/ChildLock.module";
import TrafficPart from "./TrafficPart/TrafficPart.module";
import DaysRemaining from "./DaysRemaining/DaysRemaining.module";
import GameMode from "./GameMode/GameMode.module";
import ViewSetting from "./ViewSettings/ViewSetting.module";
import InternalIPs from "./InternalIps/InternalIPs.module";
import OuterIPs from "./OuterIps/OuterIPs.module";
import IsOnline from "./IsOnline/IsOnline.module";
import { i } from "framer-motion/client";
import BlueBtn from "../BlueBtn/BlueBtn.module";
import AccountType from "./AccountType/AccountType.module";
import YtAdBlocker from "./YtAdBlocker/YtAdBlocker.module";
import Wireguard from "../VpnTypes/Wireguard.module";
import Ovpn from "../VpnTypes/Ovpn.Module";
import ConfigDownload from "./UserActions/ConfigDownload.module";
import ConfigRenew from "./UserActions/ConfigRenew.module";
import Repair from "./UserActions/Repair.module";
import SeperatorBlue from "../SeperatorBlue/SeperatorBlue.module";
import CtaBtns from "../CtaBtns/CtaBtns.module";
const UserCard = ({
  item,
  onBuyTraffic,
  getInfo,
  loadingShower,
  onMainPage,
  countryInfo,
  modalOpener,
}) => {
  const {
    openUpModal,
    description,
    confirmTitle,
    payloadConfirm,
    toDo,
    closeModal,
  } = React.useContext(ConfirmationModalContext);
  const navigate = useNavigate();
  const { onLogout } = React.useContext(AuthContext);
  const { loading, fetchWithToken } = useFetchWithToken();
  useEffect(() => {
    loadingShower(loading);
  }, [loading]);

  const isServiceActive = (time) =>
    time.days > 0 || time.hours > 0 || time.minutes > 0;

  return (
    <div className={styles.usercard}>
      {item.disabled === "true" && (
        <>
          <div className={styles.deactivated}></div>
          <div className={styles.deactivatedText}>
            <div className={styles.inCenter}>
              <div className={styles.textInDe}>
                <i className="fa-regular fa-exclamation-circle"></i>
                این اکانت غیرفعال می باشد
              </div>
              <div className={styles.containDescTr}>
                {isServiceActive(item.remainingTime) ? (
                  <>
                    <div className={styles.descinDeac}>
                      <div className={styles.descerInS}>
                        این اکانت به دلیل اتمام ترافیک، غیرفعال گردیده! از طریق
                        قسمت پایینی میتوانید ترافیک مورد نیاز خود را تهیه
                        نمایید.
                      </div>
                    </div>
                    {onMainPage && (
                      <>
                        <TrafficPart
                          onDisabled={true}
                          item={item}
                          getInfo={getInfo}
                          onBuyTraffic={onBuyTraffic}
                          isServiceActive={isServiceActive}
                        />
                      </>
                    )}
                  </>
                ) : (
                  <div className={styles.descinDeac}>
                    <div className={styles.descerInS}>
                      این اکانت به دلیل اتمام روز های باقی مانده غیر فعال
                      گردیده. جهت استفاده مجدد، آن را تمدید نمایید.
                    </div>
                    <CtaBtns
                      onAtion={() => {
                        navigate("/account-renew");
                      }}
                    >
                      تمدید اکانت
                    </CtaBtns>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      {item.gameMode && <div className={styles.usercardImage}></div>}
      {item.autorenew !== 0 && (
        <div className={styles.topcard}>
          <div className={styles.renewactive}>
            تمدید خودکار
            <i class="fa-light fa-bolt-auto"></i>
          </div>
        </div>
      )}
      <div className={styles.accInfo}>
        <div className={styles.rightAccName}>
          <i class="fa-regular fa-address-card"></i>
          <div className={styles.leftpartAc}>
            <div className={styles.accName}>{item.accountName}</div>
            <div className={styles.packName}> {item.packageName}</div>
          </div>
        </div>

        <div className={styles.righytr}>
          {item.type == "Wireguard" && (
            <Wireguard onMainPage={onMainPage} item={item} />
          )}
          {item.type == "Ovpn" && <Ovpn onMainPage={onMainPage} item={item} />}
          {!onMainPage && <IsOnline item={item} />}
        </div>
      </div>
      <div className={styles.wholeC}>
        {/* <div className={styles.downtop}>
          <div className={styles.actions}>
            <div className={styles.coler}>
              {item.contain.configstatus === "true" && (
                <div className={styles.eachBtn}>
                  <div
                    className={styles.downloadbtn}
                    onClick={() => downloadConfig()}
                  >
                    <i className="fal fa-download"></i>
                  </div>
                  <div className={styles.desconuser}>دریافت کانفیگ</div>
                </div>
              )}
              {item.type == "Wireguard" && (
                <div className={styles.eachBtn}>
                  <div
                    className={styles.downloadbtn}
                    onClick={() => troubleShootAccount()}
                  >
                    <i class="fal fa-user-doctor"></i>
                  </div>
                  <div className={styles.desconuser}>عیب یابی</div>
                </div>
              )}

              <div className={styles.eachBtn}>
                <div
                  className={styles.downloadbtn}
                  onClick={() => createNewAccessConfig()}
                >
                  <i className="fal fa-arrows-rotate-reverse"></i>
                </div>
                <div className={styles.desconuser}>ایجاد کانفیگ جدید</div>
              </div>
            </div>
            {item.type == "Wireguard" && (
              <img width="40" src="/asets/wireg.png" />
            )}
            {(item.type == "Ovpn" || item.type == "Ovpns") && (
              <img width="40" src="/asets/ovp.svg" />
            )}
          </div>
        </div> */}
        <div className={styles.containcardinfo}>
          <div className={styles.carddetails}>
            {!onMainPage && (
              <div className={styles.twoColer}>
                <div className={styles.cols}>
                  <ChildLock
                    item={item}
                    getInfo={getInfo}
                    loadingShower={loadingShower}
                  />
                  {/* <YtAdBlocker
                    item={item}
                    getInfo={getInfo}
                    loadingShower={loadingShower}
                  /> */}
                  {item.irluxeVpnManager && (
                    <>
                      <CountrySelection
                        countryInfo={countryInfo}
                        details={item}
                        loadingShower={loadingShower}
                        getInfo={getInfo}
                      />
                      {/* <GameMode
                        item={item}
                        getInfo={getInfo}
                        loadingShower={loadingShower}
                      /> */}
                    </>
                  )}
                </div>
                <div className={styles.cols}>
                  {item.irluxeVpnManager && (
                    <>
                      <TrafficPart
                        onDisabled={false}
                        item={item}
                        getInfo={getInfo}
                        onBuyTraffic={onBuyTraffic}
                        isServiceActive={isServiceActive}
                      />
                      {/* <div className={styles.littleSep}></div> */}
                      <InternalIPs item={item} />
                      <div className={styles.littleSep}></div>
                      <OuterIPs item={item} />
                    </>
                  )}
                </div>
              </div>
            )}
            {onMainPage && (
              <>
                <AccountType account={item} />
                {item.irluxeVpnManager && <ViewSetting accountId={item.id} />}
                <DaysRemaining item={item} getInfo={getInfo} />
                <TrafficPart
                  onDisabled={false}
                  item={item}
                  getInfo={getInfo}
                  onBuyTraffic={onBuyTraffic}
                  isServiceActive={isServiceActive}
                />
              </>
            )}
          </div>
          {item.price !== 0 && (
            <>
              {"discounts" in item && (
                <div className={styles.descer}>
                  <i class="fal fa-exclamation-circle"></i>
                  {item.discounts.discountReason}
                  <br />
                  {NumberComponent(item.discounts.discountPercent)}% تخفیف
                </div>
              )}
            </>
          )}
          <div className={styles.downpartaction}>
            <ConfigDownload loadingShower={loadingShower} item={item} />
            <ConfigRenew
              loadingShower={loadingShower}
              item={item}
              getInfo={getInfo}
            />
            {item.type == "Wireguard" && (
              <Repair
                loadingShower={loadingShower}
                item={item}
                getInfo={getInfo}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCard;
